export default __webpack_public_path__ + "static/Theworldtravellerwhoneverlefthome-0fdcc8039e828a74f0906d4d9d75ebe6.jpg";